import React, { useEffect, useRef } from 'react'

import { useRecoilValue, useRecoilCallback } from 'recoil'

import {
  Loading,
  ToastContainer,
  Tooltip,
  SpacingVertical,
  SPACING_16,
  SPACING_32
} from 'mailup-web-components'

import Header from './Header'

import { pageErrorState, loadingState } from './recoil/state/page'

import {
  fetchInitialResultsCallback,
  fetchPecPlusConfigCallback,
  reloadResultsCallback
} from './recoil/callbacks/callbacks'

import ErrorFeedback from './ErrorFeedback'

import { ListSending } from './ListSending'
import { ListScheduled } from './ListScheduled'
import { ListWaiting } from './ListWaiting'

import PecPlusError from './PecPlusError'
import PecPlusInProgress from './PecPlusInProgress'
import GracePeriodWarning from './GracePeriodWarning'

import ModalStopSending from './ModalStopSending'
import ModalStopCampaign from './ModalStopCampaign'
import ModalDeleteSending from './ModalDeleteSending'
import ModalSendingSegmentation from './ModalSendingSegmentation'
import ModalSchedule from './ModalSchedule'

import './CampaignsSendStatus.scss'
import ModalFasciaDiNonDisturbo from './ModalFasciaDiNonDisturbo/ModalFasciaDiNonDisturbo'

const RELOAD_INTERVAL = 15 * 1000 //  15s

const CampaignsSendStatus = () => {
  const loading = useRecoilValue(loadingState)
  const { error } = useRecoilValue(pageErrorState)

  const loadInitialResults = useRecoilCallback(fetchInitialResultsCallback, [])
  const loadPecPlusConfig = useRecoilCallback(fetchPecPlusConfigCallback, [])
  const reloadResults = useRecoilCallback(reloadResultsCallback, [])

  const timer = useRef(true)

  useEffect(() => {
    loadPecPlusConfig()

    loadInitialResults()

    timer.current = setInterval(reloadResults, RELOAD_INTERVAL)

    return () => clearInterval(timer.current)
  }, [])

  return (
    <>
      <Tooltip />
      <Loading open={loading} />
      <Header />
      <ToastContainer />
      <ModalStopSending />
      <ModalStopCampaign />
      <ModalDeleteSending />
      <ModalSchedule />
      <ModalSendingSegmentation />
      <ModalFasciaDiNonDisturbo />
      <div className='l-container'>
        <ErrorFeedback />
        <GracePeriodWarning />
        {!error && !loading && (
          <React.Suspense fallback={null}>
            <PecPlusError />
            <PecPlusInProgress />
            <ListSending />
            <SpacingVertical variant={SPACING_16} />
            <SpacingVertical variant={SPACING_32} />
            <ListScheduled />
            <SpacingVertical variant={SPACING_16} />
            <SpacingVertical variant={SPACING_32} />
            <ListWaiting />
            <SpacingVertical variant={SPACING_16} />
          </React.Suspense>
        )}
      </div>
    </>
  )
}

export default CampaignsSendStatus
